import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-card">
          <div className="about-image-column">
            <img 
              src="/images/banners/freepik__the-style-is-candid-image-photography-with-natural__24137.webp" 
              alt="Rahar Decors Celebration" 
              className="about-image"
            />
          </div>
          <div className="about-content-column">
            <h2 className="about-heading">
              Welcome to <span className="cursive-brand">Rahar Decors</span>
            </h2>
            <div className="about-text">
              <p>
                At Rahar Decors, we believe that every celebration deserves a touch of elegance, joy, and unforgettable memories. 
                Established with a passion for creating magical moments, we specialize in premium balloon decorations and event styling.
              </p>
              <p>
                Our team transforms ordinary spaces into extraordinary experiences for birthdays, parties, anniversaries, baby showers, 
                theme parties, and welcome baby celebrations. We use only premium materials and create personalized designs that reflect 
                your unique style and vision.
              </p>
            </div>
            <div className="about-stats">
              <div className="stat-circle stat-red">
                <div className="stat-number">5L+</div>
                <div className="stat-label">CLIENTS</div>
              </div>
              <div className="stat-circle stat-purple">
                <div className="stat-number">50+</div>
                <div className="stat-label">EXPERT WORKERS</div>
              </div>
              <div className="stat-circle stat-orange">
                <div className="stat-number">10K+</div>
                <div className="stat-label">DONE PROJECTS</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
